import question from '../support/question';
import $ from 'jquery';

const selectors = {
	$faqPage: '.js-faq-page',
	$accord: '.js-accordeon',
	$accordItem: '.js-accordeon-item',
	$accordAllOpenClose: '.js-faq-section-all-open',
	accordOpen: 'accordeon__item_state_active',
	$accordContent: '.js-accordeon-content',
	$accordWrap: '.js-accordeon-wrap',
	questionsOpened: 'questions-opened'
};

const accordeonToggle = (el, ev) => {
	if (ev) {
		el.closest(selectors.$accord).find(selectors.$accordItem).addClass(selectors.accordOpen);
		el.closest(selectors.$accord).find(selectors.$accordContent).each(function () {
			$(this).closest(selectors.$accordWrap).height($(this).outerHeight());
		});
	} else {
		el.closest(selectors.$accord).find(selectors.$accordItem).removeClass(selectors.accordOpen);
		el.closest(selectors.$accord).find(selectors.$accordContent).each(function () {
			$(this).closest(selectors.$accordWrap).height(0);
		});
	}
};

const faqAll = () => {
	const textDown = 'открыть все ответы';
	const textUp = 'скрыть ответы';
	$(selectors.$accordAllOpenClose).on('click', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).find('span').text(textDown);
			$(this).closest(selectors.$faqPage).removeClass(selectors.questionsOpened);
			accordeonToggle($(this), false);
		} else {
			$(this).addClass('active');
			$(this).find('span').text(textUp);
			$(this).closest(selectors.$faqPage).addClass(selectors.questionsOpened);
			accordeonToggle($(this), true);
		}
	});
	$(selectors.$accordItem).on('click', function () {
		if ($(this).closest(selectors.$faqPage).hasClass(selectors.questionsOpened)) {
			$(this).closest(selectors.$faqPage).find(selectors.$accordItem).removeClass(selectors.accordOpen);
			$(this).closest(selectors.$faqPage).find(selectors.$accordItem).find(selectors.$accordWrap).height(0);
			$(this).closest(selectors.$faqPage).removeClass(selectors.questionsOpened);
		}
		$(this).closest(selectors.$accord).find(selectors.$accordAllOpenClose).removeClass('active');
		$(this).closest(selectors.$accord).find(selectors.$accordAllOpenClose).find('span').text(textDown);
	});
};

const render = () => {
	faqAll();
	question();
};

export default render;
